module.exports = __webpack_public_path__ + "promotion-banner-desktop-siwk.ce4ef57988cab0d7b901b8858ae0625a.png";